import React, { PropTypes } from 'react';

import MainPage from './_mainPage';

export const PAGE_ID = 'main';

class IndexPage extends React.Component {
  static propTypes = {
    displayType: PropTypes.string,
    showedOverlay: PropTypes.string,
    setOverlay: PropTypes.func
  };

  render() {
    const { displayType, showedOverlay, setOverlay } = this.props;

    return (
      <MainPage
        displayType={displayType}
        showedOverlay={showedOverlay}
        setOverlay={setOverlay}
        currentPageName={PAGE_ID}
      />
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./index.js